import { FETCH_MTOKNA_SCHEMES, CLEAN_MTOKNA_SCHEMES, CHANGE_MTOKNA_SCHEME, DELETE_MTOKNA_SCHEME } from '../actions/types';
import _ from 'lodash';
import { toNumber } from '../functions';

const MTOKNA_SCHEMES_DEFAULT_STATE = {};

const MtoknaSchemesReducer = (state = MTOKNA_SCHEMES_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_MTOKNA_SCHEMES:
            return payload;

        case CHANGE_MTOKNA_SCHEME:
            return { ...state, items: _.map(state.items, item => {
                if (toNumber(item.id) === toNumber(payload.id)) {
                    item = { ...item, data: payload.data };
                }

                return item;
            }) };

        case CLEAN_MTOKNA_SCHEMES:
        case DELETE_MTOKNA_SCHEME:
            return MTOKNA_SCHEMES_DEFAULT_STATE;

        default:
            return state;
    }
};

export default MtoknaSchemesReducer;
